import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../Checkbox/Checkbox';

import './OptionalTextBox.css';
import { checkIsNA } from '../../../utils';

export default class OptionalTextBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textFieldValue: ""
    };
  }

  componentWillMount() {
    if (this.props._value !== undefined) {
      var naValue = this.props.naValue ? this.props.naValue.toLowerCase() : 'n/a';
      if (this.props._value.toLowerCase() === naValue) {
        this.setState({
          textFieldValue: this.props._value,
          isNA: true
        });
      } else {
        this.setState({
          textFieldValue: this.props._value,
          isNA: false
        });
      }
    } else if (this.props.disabled !== undefined) {
      if (this.props.disabled) {
        this.setState({
          isNA: true,
          textFieldValue: "N/A"
        });
      } else {
        this.setState({
          textFieldValue: "N/A",
          isNA: true
        });
      }
    }

    if (this.props.isNewCreated) {
      this.setState({
        textFieldValue: "N/A",
        isNA: true
      });
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   if(nextProps._value !== undefined) {
  //     if(nextProps._value.toLowerCase() === (nextProps.naValue || "n/a")) {
  //       this.setState({
  //         textFieldValue: nextProps._value,
  //         isNA: true
  //       });
  //     }else {
  //       this.setState({
  //         textFieldValue: nextProps._value,
  //         isNA: false
  //       });
  //     }
  //   }
  // }

  onChecked = (event) => {
    if (event.target.checked) {
      this.setState({
        textFieldValue: this.props.naValue || "N/A",
        isNA: true
      }, () => {
        this.props.setInputvalue(this.state.textFieldValue, this.props.name);
      });
    } else {
      this.setState({
        textFieldValue: "",
        isNA: false
      }, () => {
        this.props.setInputvalue(this.state.textFieldValue, this.props.name);
      });
    }
  }

  handleInputChange = (event) => {
    this.setState({
      textFieldValue: checkIsNA(event.target.value),
      isNA: checkIsNA(event.target.value, true)
    });
    this.props.setInputvalue(event.target.value, event.target.name, event);
  }

  render() {
    return (
      <div className="optional-text-box">
        <input className="optional-text-box__input"
          type="text"
          value={this.state.textFieldValue}
          name={this.props.name}
          minLength={this.props.min}
          maxLength={this.props.max}
          onChange={this.handleInputChange}
          disabled={this.state.isNA || this.props.disabled} />
        <div className="optional-text-box__checkbox">
          <Checkbox
            onChange={this.onChecked}
            id={this.props.name + 'na'}
            name={`${this.props.fieldPrefix}-${this.props.name}na`}
            disabled={this.props.disabled}
            defaultChecked={this.state.isNA}
            checked={this.state.isNA}
          />
          <label htmlFor={this.props.name + 'na'} className="product-enablement-text">{this.props.naValue || 'N/A'}</label>
        </div>
      </div>
    );
  }
}


OptionalTextBox.defaultProps = {
  min: 1,
  max: 10
}

OptionalTextBox.propTypes = {
  name: PropTypes.string.isRequired,
  setInputvalue: PropTypes.func.isRequired,
  min: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  max: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  _value: PropTypes.string,
  naValue: PropTypes.string,
  fieldPrefix: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/common/OptionalTextBox/OptionalTextBox.js